import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { absenceTypeInitialsForadd, absenceTypeInitialsForUpdate } from './interfaces/absenceTypeClass';
import { addAccountAbsenceTypeAsync, updateAccountAbsenceTypeAsync, resetSelectedRecordObjectInState } from './absenceTypeSlice';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { getValueFromResource } from '../../../common/timeLiveFunction';


const AbsenceTypeForm = (props: any) => {
    const { modelRef, t, oncloseModal } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(absenceTypeInitialsForadd);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.absenceType);
    const dispatch = useAppDispatch();

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(absenceTypeInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(absenceTypeInitialsForadd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }

    }, [selectedRecord])

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountAbsenceTypeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Absence type Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            dispatch(addAccountAbsenceTypeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Absence type Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        oncloseModal();
    }

    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    AbsenceDescription: yup
                        .string()
                        .label('AbsenceDescription')
                        .trim()
                        .required(t('Absence type is required'))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                        <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? t('Update') : t('Add')} {t('Absence Type')} </h5>
                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                            <div className="mb-0">
                                                                <label className="fs-7 fw-normal mb-2">
                                                                    {/* {t('Absence Type')} */}
                                                                    {getValueFromResource('Absence Type',dispatch, t)}
                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal" id='AbsenceDescription' value={values.AbsenceDescription} name='AbsenceDescription'
                                                                    onChange={handleChange('AbsenceDescription')}
                                                                    // onBlur={() => setFieldTouched('AbsenceDescription')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('AbsenceDescription', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5}}>
                                                                {touched.AbsenceDescription && errors.AbsenceDescription &&
                                                                    <p className='errorMsg'>{errors.AbsenceDescription as string}</p>
                                                                }
                                                            </div>
                                                            {Object.keys(selectedRecord).length > 0 ? (
                                                                <div className="mb-3" >
                                                                    <label className="fs-7 fw-normal mb-2 mt-2">
                                                                        {/* {t('Disabled')} */}
                                                                        {getValueFromResource('Disabled',dispatch, t)}

                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                            onClick={oncloseModal}
                                                        >
                                                            {/* {t('Cancel')} */}
                                                            {getValueFromResource('Cancel',dispatch, t)}
                                                        </button>
                                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                        {/* {t('Save')}*/}
                                                        {getValueFromResource('Save',dispatch, t)}
                                                         </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>
    )
    // const { modelRef } = props;
    // const [currentFieldsData, setCurrentFieldsData] = useState<any>(absenceTypeInitialsForadd);
    // const { selectedRecord,isLoading } = useAppSelector((state) => state.absenceType);
    // const dispatch = useAppDispatch();
    // useEffect(() => {

    //     let stateItem: any = {}
    //     if (Object.keys(selectedRecord).length > 0) {

    //         const tempObj: any = selectedRecord;
    //         Object.keys(absenceTypeInitialsForUpdate).map((item) => {
    //             return stateItem[item] = tempObj[item];
    //         })
    //         stateItem.IsDisabled = stateItem.IsDisabled === "Yes" ? true : false;
    //         setCurrentFieldsData(stateItem);
    //     }
    //     else {
    //         setCurrentFieldsData(absenceTypeInitialsForadd);
    //     }
    // }, [selectedRecord])
    // const handleTextChange = (e: any) => {
    //     setCurrentFieldsData({...currentFieldsData, [e.target.id]:  (e.target.type==='checkbox' ? e.target.checked : e.target.value)})
    // }
    // const closeButtonRef = useRef<HTMLButtonElement | null>(null);


    // const handleSubmit = (values: any) => {
    //     //e.preventDefault();
    //     if (Object.keys(selectedRecord).length > 0) {

    //         dispatch(updateAccountAbsenceTypeAsync(values))
    //             .unwrap()
    //             .then((originalPromiseResult) => {
    //                 originalPromiseResult.StatusCode ==="200"  ?
    //                 ShowToast(originalPromiseResult.message, 'Success', "success", "toast-top-right") :
    //                 ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");

    //             })
    //             .catch((rejectedValueOrSerializedError) => {
    //                 ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
    //             })
    //     }
    //     else {
    //         dispatch(addAccountAbsenceTypeAsync(values))
    //             .unwrap()
    //             .then((originalPromiseResult) => {
    //                 originalPromiseResult.StatusCode ==="201"  ?
    //                     ShowToast(originalPromiseResult.message, 'Success', "success", "toast-top-right") :
    //                     ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");
    //                     
    //             })
    //             .catch((rejectedValueOrSerializedError) => {
    //                 ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
    //             })
    //     }
    //     if (closeButtonRef.current) {
    //         closeButtonRef.current.click();
    //     }
    // }
    // const handleCloseOnClickEvent = () => {
    //     dispatch(resetSelectedRecordObjectInState());
    // }
    // return (
    //     <>
    //     <Formik
    //         initialValues={currentFieldsData}
    //         enableReinitialize={true}
    //         onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
    //         validationSchema={yup.object().shape({
    //             AbsenceDescription: yup
    //                 .string()
    //                 .label('AbsenceDescription')
    //                 .trim()
    //                 .required('Absence Type is required')
    //         })}>
    //         {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
    //             <Fragment>
    //                 <form>
    //                     <div className='card-body'>
    //                     {isLoading ?
    //                         <div className="col-md-12">
    //                             <span className='indicator-progress' style={{ display: 'block' }}>
    //                                 <span className='spinner-border spinner-border-md ms-2'></span>
    //                             </span>
    //                         </div>
    //                         : <>
    //                         <div className='row'>
    //                             <div className="col-md-12 mb-2">
    //                                 <label className="form-label">Absence Type</label>
    //                                 <input type="text" className="form-control" id='AbsenceDescription' value={values.AbsenceDescription} name='AbsenceDescription'
    //                                     onChange={handleChange('AbsenceDescription')}
    //                                     onBlur={() => setFieldTouched('AbsenceDescription')}
    //                                 />
    //                             </div>
    //                             <div style={{ paddingRight: 20, paddingLeft: 20 }}>
    //                                 {touched.AbsenceDescription && errors.AbsenceDescription &&
    //                                     <p className='errorMsg'>{errors.AbsenceDescription as string}</p>
    //                                 }
    //                             </div>
    //                             {Object.keys(selectedRecord).length > 0 ? (
    //                                 <div className="col-md-12">
    //                                     <label className="form-label">Disabled</label>
    //                                     <div className="form-check form-switch form-check-custom form-check-solid me-10">
    //                                         <input className="form-check-input h-20px w-30px" type="checkbox" 
    //                                         checked={values.IsDisabled} id="IsDisabled" 
    //                                         onChange={handleChange('IsDisabled')}
    //                                         />
    //                                     </div>
    //                                 </div>
    //                             ) : null}
    //                         </div>
    //                         </>
    //                     }
    //                     </div>
    //                     <div className='card-footer pt-4 '>
    //                         <div className='d-flex flex-stack float-end'>
    //                             <div className='d-flex align-items-center me-2'>
    //                                 <button
    //                                      ref={closeButtonRef}
    //                                     type="button"
    //                                     className="btn btn-light btn-sm me-2"
    //                                     id="kt_OffCanvas"
    //                                     onClick={handleCloseOnClickEvent}
    //                                 >
    //                                     Close
    //                                 </button>

    //                                 <button  type="button" data-kt-element='send' className="btn btn-light-primary btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
    //                                    {Object.keys(selectedRecord).length > 0 ? 'Update' : 'Add'} Absence Type
    //                                 </button>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </form>
    //             </Fragment>
    //         )}
    //     </Formik>
    // </>
    // )
}


export default AbsenceTypeForm